export default function (request, { urltemplate }) {
  const prefix = process.env.VUE_APP_API_SERVER

  return {
    /**
     * 获取OEM信息
     */
    getOemInfo ({ query }) {
      return request({
        url: `${prefix}/oem/company`,
        method: 'get',
        params: query
      })
    }

  }
}
